import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';

import { GetPaymentDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import numberFormatter from '../../../common/numberFormatter';

interface Props {
  examId: string;
}

export const ExamPortalPaymentAlert: React.FC<Props> = ({ examId }) => {
  const spd = useSpdCore();
  const [payments, setPayments] = useState<GetPaymentDto[]>([]);
  const [hasInvoice, setHasInvoice] = useState(false);
  const [hasReceipt, setHasReceipt] = useState(false);

  useEffect(() => {
    void Promise.all([
      spd.payments.getByExamId(examId),
      spd.salesInvoices.getByExamId(examId),
      spd.receipts.getByExamId(examId),
    ]).then(([portalPayments, invoices, receipts]) => {
      setPayments(portalPayments);
      setHasInvoice(invoices.length > 0);
      setHasReceipt(receipts.length > 0);
    });
  }, [examId, spd.payments, spd.salesInvoices, spd.receipts]);

  if (payments.length === 0 || hasInvoice || hasReceipt) {
    return null;
  }

  return (
    <>
      {payments.map(payment => (
        <Alert key={payment.id} variant="info">
          Zapłacono {numberFormatter(payment.amount, true)} w portalu badanego
          (nr sys. płatności w portalu: {payment.sysNumber}{' '}
          {payment?.invoicePayment?.systemNumber
            ? ', nr sys. wpłaty ' + payment?.invoicePayment?.systemNumber
            : ''}
          ).
        </Alert>
      ))}
    </>
  );
};
